// eslint-disable-next-line import/no-extraneous-dependencies
import { createGenerateClassName } from '@material-ui/core/styles';
import { merge } from 'lodash';
import CampaignCommitment from '../../../src/giving/public/campaignCommitment/campaignCommitment';
import commitmentWidgetI18nResources from '../../../src/giving/public/campaignCommitment/translations';
import GivingHistory from '../../../src/giving/public/givingHistory/givingHistory';
import givingHistoryWidgetI18nResources from '../../../src/giving/public/givingHistory/translations';
import WidgetType from '../../models/widgetType.model';
import loadWidgetsIntoHtmlConsumers from '../../shared/widgetLoaderUtil';

/**
 * Public Giving widgets offered to external HTML consumers (e.g. saddleback.com).
 *
 * Trimmed to Campaign Commitment and Giving History under AB#112440, which retired the Giving Checkout, Campaign
 * Details, Designation Details, Giving Opportunities, My Commitments, My Scheduled & Recurring and Saved Payment
 * Methods surfaces.  Before removing those widget types, saddleback.com was swept for
 * `data-hc-widget-type="<value>"` embeds and none of the retired types were in use.
 */
const widgetAppMap: Map<WidgetType, Function> = new Map<WidgetType, Function>([
    [WidgetType.GivingCampaignCommitment, CampaignCommitment],
    [WidgetType.GivingHistory, GivingHistory],
]);

// Both giving widgets share a single i18next instance (the loader's `setupI18n` re-initializes it on
// each call), so their translation resources must be merged and passed identically to every widget —
// passing per-widget resources would leave only the last-loaded widget's translations registered.
// Key collisions are avoided by namespace: the Campaign Commitment widget uses `common`/`viewCommitment`
// and the Giving History widget uses `statements`/`paymentActivity`.
const mergedGivingWidgetI18nResources = merge(
    {},
    commitmentWidgetI18nResources,
    givingHistoryWidgetI18nResources,
);

widgetAppMap.forEach((App: Function, widgetType: WidgetType) => {
    // eslint-disable-next-line no-console
    console.log(`Healthy Church Widgets: Loading widgets of type '${widgetType}' ...`);

    loadWidgetsIntoHtmlConsumers({
        App,
        widgetType,
        generateClassName: createGenerateClassName({
            productionPrefix: widgetType,
        }),
        i18nResources: mergedGivingWidgetI18nResources,
    });
});
